// extracted by mini-css-extract-plugin
export default {"type-button":"z7EIKkk8PrPP2ALqR2WV","type-label":"TYu0GWhMe24Miw2LLd8P","selection-icon":"bEBUQWSQidhpNZvVJgoB"};